import { Routes, Route } from "react-router-dom"
import Globalstyle from "./Globalstyle"
import Landing from "./routes/Landing"
import SylhetReliefLanding from "./routes/SylhetReliefLanding"
import Donate from "./routes/Donate"
import ScrollToTop from "./components/ScrollToTop"
import "./assets/fonts/gilroy/stylesheet.css"


const App = () => {
  return (
    <div>
      <Globalstyle/>
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<SylhetReliefLanding/>}/>
          <Route path="donate" element={<Donate/>}/>
          <Route path="about-us" element={<Landing/>}/>
        </Routes>
      </ScrollToTop>
    </div>
  )
}

export default App